import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/Outboardingcontabil.css';

const Outboarding = () => {
  const [empresasEmProcesso, setEmpresasEmProcesso] = useState([]);
  const [empresasFinalizadas, setEmpresasFinalizadas] = useState([]);
  const [totalEmpresas, setTotalEmpresas] = useState(0);
  const [carregando, setCarregando] = useState(true);
  const [atualizadoEm, setAtualizadoEm] = useState(null);
  const [erro, setErro] = useState(null);
  const [filtro, setFiltro] = useState('');
  const [abaAtiva, setAbaAtiva] = useState('emProcesso');

  useEffect(() => {
    const carregarOutboarding = async () => {
      try {
        const accessToken = localStorage.getItem('access');
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE}/api/customerx-outboarding-completo/`,
          {
            headers: { Authorization: `Bearer ${accessToken}` }
          }
        );

        setEmpresasEmProcesso(response.data.empresas_em_processo || []);
        setEmpresasFinalizadas(response.data.empresas_finalizadas || []);
        setTotalEmpresas(response.data.total || 0);
        // Data/hora da última carga da tabela cx_outboarding (script cx.py).
        setAtualizadoEm(response.data.timestamp || null);
        setCarregando(false);
      } catch (error) {
        console.error('Erro ao carregar outboarding:', error);
        setErro('Não foi possível carregar os dados');
        setCarregando(false);
      }
    };

    carregarOutboarding();
  }, []);

  const filtrarEmpresas = (listaEmpresas) => {
    return listaEmpresas.filter(empresa =>
      (empresa.Empresa && empresa.Empresa.toLowerCase().includes(filtro.toLowerCase())) ||
      (empresa['Responsável Contábil'] &&
       empresa['Responsável Contábil'].toLowerCase().includes(filtro.toLowerCase()))
    );
  };

  const empresasProcessoFiltradas = filtrarEmpresas(empresasEmProcesso);
  const empresasFinalizadasFiltradas = filtrarEmpresas(empresasFinalizadas);

  const renderLinha = (empresa, index) => (
    <tr key={empresa.external_id || index}>
      <td className="fw-bold">{empresa.Empresa}</td>
      <td>{empresa['Responsável Contábil'] || '-'}</td>
      <td>{empresa['Nº Dominio'] || '-'}</td>
      <td>
        {(empresa.status_documentacao || '').toLowerCase() === 'concluída' ? (
          <span className="badge bg-success">
            <i className="fas fa-check-circle me-1"></i>Concluída
          </span>
        ) : (
          <span className="badge bg-warning text-dark">
            <i className="fas fa-exclamation-circle me-1"></i>
            {empresa.status_documentacao && empresa.status_documentacao !== '-'
              ? empresa.status_documentacao
              : 'Pendente'}
          </span>
        )}
      </td>
      <td>
        {empresa.dominio_existe_no_banco ? (
          <span className="badge bg-success">
            <i className="fas fa-check me-1"></i>Sim
          </span>
        ) : (
          <span className="badge bg-danger">
            <i className="fas fa-times me-1"></i>Não
          </span>
        )}
      </td>
    </tr>
  );

  const renderTabela = (lista, classeHead, vazioMsg) => (
    <div className="table-responsive">
      <table className="table table-striped table-hover mb-0">
        <thead className={classeHead}>
          <tr>
            <th>Empresa</th>
            <th>Responsável Contábil</th>
            <th>Nº Domínio</th>
            <th>Status Documentação</th>
            <th>No banco?</th>
          </tr>
        </thead>
        <tbody>
          {lista.length > 0 ? (
            lista.map(renderLinha)
          ) : (
            <tr>
              <td colSpan="5" className="text-center py-4">
                <i className="fas fa-info-circle text-muted me-2"></i>
                {vazioMsg}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  if (carregando) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Carregando...</span>
        </div>
        <p>Carregando dados de outboarding...</p>
      </div>
    );
  }

  if (erro) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger">{erro}</div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="header-wrapper d-flex justify-content-between align-items-center mb-4">
        <div className="d-flex align-items-center">
          <i className="fas fa-hourglass-half header-icon me-3 text-warning"></i>
          <h2 className="titulo-pagina m-0">Outboarding Contábil</h2>
        </div>
      </div>

      {atualizadoEm && (
        <div className="text-muted small mb-3">
          <i className="fas fa-clock me-1"></i>
          Dados do CustomerX atualizados em: {atualizadoEm}
        </div>
      )}

      <ul className="nav nav-tabs mb-4">
        <li className="nav-item">
          <button
            className={`nav-link ${abaAtiva === 'emProcesso' ? 'active' : ''}`}
            onClick={() => setAbaAtiva('emProcesso')}
          >
            <i className="fas fa-spinner me-2"></i>
            Em Processo
            <span className="badge bg-warning text-dark ms-2">
              {empresasEmProcesso.length}
            </span>
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${abaAtiva === 'finalizado' ? 'active' : ''}`}
            onClick={() => setAbaAtiva('finalizado')}
          >
            <i className="fas fa-check-circle me-2"></i>
            Finalizados
            <span className="badge bg-success ms-2">
              {empresasFinalizadas.length}
            </span>
          </button>
        </li>
      </ul>

      <div className="mb-4">
        <div className="input-group">
          <span className="input-group-text">
            <i className="fas fa-search"></i>
          </span>
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por empresa ou responsável..."
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
          {filtro && (
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={() => setFiltro('')}
            >
              <i className="fas fa-times"></i>
            </button>
          )}
        </div>
      </div>

      {abaAtiva === 'emProcesso' && (
        <div className="card shadow-sm mb-4">
          <div className="card-header bg-warning bg-opacity-25">
            <h5 className="mb-0">
              <i className="fas fa-hourglass-half me-2 text-warning"></i>
              Empresas em Processo de Outboarding
            </h5>
          </div>
          <div className="card-body p-0">
            {renderTabela(
              empresasProcessoFiltradas,
              'table-dark',
              filtro ? 'Nenhuma empresa em processo encontrada com este filtro.' : 'Não há empresas em processo de outboarding.'
            )}
          </div>
          <div className="card-footer bg-light">
            <small className="text-muted">
              Total: {empresasProcessoFiltradas.length} empresa(s) em processo de outboarding
              {filtro ? ` (filtro aplicado)` : ''}
            </small>
          </div>
        </div>
      )}

      {abaAtiva === 'finalizado' && (
        <div className="card shadow-sm mb-4">
          <div className="card-header bg-success bg-opacity-25">
            <h5 className="mb-0">
              <i className="fas fa-check-circle me-2 text-success"></i>
              Empresas com Outboarding Finalizado
            </h5>
          </div>
          <div className="card-body p-0">
            {renderTabela(
              empresasFinalizadasFiltradas,
              'table-success',
              filtro ? 'Nenhuma empresa finalizada encontrada com este filtro.' : 'Não há empresas com outboarding finalizado.'
            )}
          </div>
          <div className="card-footer bg-light">
            <small className="text-muted">
              Total: {empresasFinalizadasFiltradas.length} empresa(s) com outboarding finalizado
              {filtro ? ` (filtro aplicado)` : ''}
            </small>
          </div>
        </div>
      )}

      <div className="row mt-4">
        <div className="col-md-6">
          <div className="alert alert-info">
            <i className="fas fa-info-circle me-2"></i>
            <strong>O que é o Outboarding?</strong>
            <p className="small mt-2 mb-0">
              Outboarding contábil é o processo de encerramento de um cliente,
              incluindo a finalização de todas as obrigações contábeis, entrega
              de documentos e registros finais antes do término da prestação de serviços.
            </p>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Resumo</h5>
              <div className="d-flex justify-content-around">
                <div className="text-center">
                  <span className="d-block fs-4 fw-bold text-warning">
                    {empresasEmProcesso.length}
                  </span>
                  <small>Em Processo</small>
                </div>
                <div className="text-center">
                  <span className="d-block fs-4 fw-bold text-success">
                    {empresasFinalizadas.length}
                  </span>
                  <small>Finalizados</small>
                </div>
                <div className="text-center">
                  <span className="d-block fs-4 fw-bold text-primary">
                    {totalEmpresas}
                  </span>
                  <small>Total</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Outboarding;
